import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from './linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { shellStringResources, IViolation, Credential } from 'shell-models-lib';
import { AuthenticationType } from 'app/interfaces/IAuthenticationType';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDataLakeStoreCosmosStructuredStream_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureDataLakeStoreCosmosStructuredStream_DisplayText)
    ]
})
export class AzureDataLakeStoreCosmosStructuredStreamLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountName
    })
    public accountName: string;

    @Metamodel.attribute({
        display: stringResources.SubscriptionId
    })
    public subscriptionId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ResourceGroupName
    })
    public resourceGroupName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant
    })
    public tenant: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: AzureDataLakeStoreCosmosStructuredStreamLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedservice: AzureDataLakeStoreCosmosStructuredStreamLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice &&
            linkedservice.authenticationType === AuthenticationType.Credential &&
            !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
